import { IconsBrands } from '../icons';
import { Brands as LogoBrands } from '../logo';
export var CaviarColors = {
  Yellow100: '#FFF0C2',
  Yellow200: '#FFCC33',
  Yellow300: '#E5B82E',
  Yellow400: '#CCA329',
  Green100: '#DFEFD9',
  Green200: '#24B324',
  Green300: '#20A120',
  Green400: '#1D8F1D',
  Red100: '#FFCCCC',
  Red200: '#D92B2B',
  Red300: '#C22626',
  Red400: '#AD2222',
  Orange100: '#FDC7B3',
  Orange200: '#F86932',
  Orange300: '#DF5F2D',
  Orange400: '#C65428',
  Blue100: '#DEF1FA',
  Blue200: '#00ACED',
  Blue300: '#009AD4',
  Blue400: '#0089BD',
  Gray100: '#FAFAFA',
  Gray200: '#EFF1F3',
  Gray300: '#CCD1D5',
  Gray400: '#6E767E',
  Gray500: '#4B5862',
  Gray600: '#2D3C48',
  Gray700: '#26333D',
  Gray800: '#1F2327'
};
export var CaviarOverrides = {
  BorderRadius: {
    ModalDefault: 4
  },
  Colors: {
    BackgroundSecondary: CaviarColors.Gray100,
    BackgroundTertiary: CaviarColors.Gray200,
    BackgroundOverlay: CaviarColors.Gray600,
    BorderPrimary: CaviarColors.Gray200,
    BorderSecondary: CaviarColors.Gray300,
    ButtonDefaultToggleForegroundDisabled: CaviarColors.Gray400,
    ButtonDefaultToggleForegroundOff: CaviarColors.Gray600,
    ButtonDefaultToggleForegroundOffDisabled: CaviarColors.Gray400,
    ButtonDefaultToggleForegroundOffHovered: CaviarColors.Gray600,
    ButtonDefaultToggleForegroundOffPressed: CaviarColors.Gray600,
    ButtonFabBackgroundHovered: CaviarColors.Gray100,
    ButtonFabBackgroundPressed: CaviarColors.Gray200,
    ButtonFabForeground: CaviarColors.Gray600,
    ButtonFabForegroundHovered: CaviarColors.Gray700,
    ButtonFabForegroundPressed: CaviarColors.Gray800,
    ButtonFlatPrimaryForeground: CaviarColors.Orange200,
    ButtonFlatPrimaryForegroundDisabled: CaviarColors.Gray100,
    ButtonFlatPrimaryForegroundHovered: CaviarColors.Orange300,
    ButtonFlatPrimaryForegroundPressed: CaviarColors.Orange400,
    ButtonFlatSecondaryForeground: CaviarColors.Gray600,
    ButtonFlatSecondaryForegroundDisabled: CaviarColors.Gray400,
    ButtonFlatSecondaryForegroundHovered: CaviarColors.Gray700,
    ButtonFlatSecondaryForegroundPressed: CaviarColors.Gray800,
    ButtonPlainBackgroundHovered: CaviarColors.Gray100,
    ButtonPlainBackgroundPressed: CaviarColors.Gray200,
    ButtonPlainForeground: CaviarColors.Gray600,
    ButtonPlainForegroundDisabled: CaviarColors.Gray400,
    ButtonPlainForegroundHovered: CaviarColors.Gray700,
    ButtonPlainForegroundPressed: CaviarColors.Gray800,
    ButtonPlainToggleBackgroundHovered: CaviarColors.Gray100,
    ButtonPlainToggleBackgroundOffHovered: CaviarColors.Gray100,
    ButtonPlainToggleBackgroundOffPressed: CaviarColors.Gray200,
    ButtonPlainToggleBackgroundPressed: CaviarColors.Gray200,
    ButtonPlainToggleForeground: CaviarColors.Gray600,
    ButtonPlainToggleForegroundDisabled: CaviarColors.Gray400,
    ButtonPlainToggleForegroundHovered: CaviarColors.Gray700,
    ButtonPlainToggleForegroundOff: CaviarColors.Gray600,
    ButtonPlainToggleForegroundOffDisabled: CaviarColors.Gray400,
    ButtonPlainToggleForegroundOffHovered: CaviarColors.Gray700,
    ButtonPlainToggleForegroundOffPressed: CaviarColors.Gray800,
    ButtonPlainToggleForegroundPressed: CaviarColors.Gray800,
    ButtonPrimaryBackground: CaviarColors.Orange200,
    ButtonPrimaryBackgroundDisabled: CaviarColors.Gray100,
    ButtonPrimaryBackgroundHovered: CaviarColors.Orange300,
    ButtonPrimaryBackgroundPressed: CaviarColors.Orange400,
    ButtonPrimaryToggleBackground: CaviarColors.Gray600,
    ButtonPrimaryToggleBackgroundDisabled: CaviarColors.Gray300,
    ButtonPrimaryToggleBackgroundHovered: CaviarColors.Gray500,
    ButtonPrimaryToggleBackgroundPressed: CaviarColors.Gray700,
    ButtonPrimaryToggleBackgroundOff: CaviarColors.Gray200,
    ButtonPrimaryToggleBackgroundOffDisabled: CaviarColors.Gray100,
    ButtonPrimaryToggleBackgroundOffHovered: CaviarColors.Gray100,
    ButtonPrimaryToggleBackgroundOffPressed: CaviarColors.Gray300,
    ButtonPrimaryToggleBorderOff: CaviarColors.Gray200,
    ButtonPrimaryToggleBorderOffHovered: CaviarColors.Gray100,
    ButtonPrimaryToggleBorderOffPressed: CaviarColors.Gray300,
    ButtonPrimaryToggleBorderOffDisabled: CaviarColors.Gray100,
    ButtonPrimaryToggleBorderOn: CaviarColors.Gray600,
    ButtonPrimaryToggleBorderOnHovered: CaviarColors.Gray500,
    ButtonPrimaryToggleBorderOnPressed: CaviarColors.Gray700,
    ButtonPrimaryToggleBorderOnDisabled: CaviarColors.Gray300,
    ButtonPrimaryToggleForegroundOff: CaviarColors.Gray600,
    ButtonPrimaryToggleForegroundOffDisabled: CaviarColors.Gray400,
    ButtonPrimaryToggleForegroundOffHovered: CaviarColors.Gray600,
    ButtonPrimaryToggleForegroundOffPressed: CaviarColors.Gray600,
    ButtonSecondaryBackground: CaviarColors.Gray600,
    ButtonSecondaryBackgroundDisabled: CaviarColors.Gray100,
    ButtonSecondaryBackgroundHovered: CaviarColors.Gray700,
    ButtonSecondaryBackgroundPressed: CaviarColors.Gray800,
    ButtonSecondaryForeground: 'SystemWhite',
    ButtonSecondaryForegroundDisabled: CaviarColors.Gray400,
    ButtonSecondaryForegroundHovered: 'SystemWhite',
    ButtonSecondaryForegroundPressed: 'SystemWhite',
    ButtonSecondaryToggleBackground: CaviarColors.Gray600,
    ButtonSecondaryToggleBackgroundDisabled: CaviarColors.Gray300,
    ButtonSecondaryToggleBackgroundHovered: CaviarColors.Gray500,
    ButtonSecondaryToggleBackgroundPressed: CaviarColors.Gray700,
    ButtonSecondaryToggleBackgroundOff: CaviarColors.Gray200,
    ButtonSecondaryToggleBackgroundOffDisabled: CaviarColors.Gray100,
    ButtonSecondaryToggleBackgroundOffHovered: CaviarColors.Gray100,
    ButtonSecondaryToggleBackgroundOffPressed: CaviarColors.Gray300,
    ButtonSecondaryToggleBorderOff: CaviarColors.Gray200,
    ButtonSecondaryToggleBorderOffHovered: CaviarColors.Gray100,
    ButtonSecondaryToggleBorderOffPressed: CaviarColors.Gray300,
    ButtonSecondaryToggleBorderOffDisabled: CaviarColors.Gray100,
    ButtonSecondaryToggleBorderOn: CaviarColors.Gray600,
    ButtonSecondaryToggleBorderOnHovered: CaviarColors.Gray500,
    ButtonSecondaryToggleBorderOnPressed: CaviarColors.Gray700,
    ButtonSecondaryToggleBorderOnDisabled: CaviarColors.Gray300,
    ButtonSecondaryToggleForegroundOff: CaviarColors.Gray600,
    ButtonSecondaryToggleForegroundOffDisabled: CaviarColors.Gray400,
    ButtonSecondaryToggleForegroundOffHovered: CaviarColors.Gray600,
    ButtonSecondaryToggleForegroundOffPressed: CaviarColors.Gray600,
    ButtonTertiaryBackground: CaviarColors.Gray200,
    ButtonTertiaryBackgroundDisabled: CaviarColors.Gray100,
    ButtonTertiaryBackgroundHovered: CaviarColors.Gray300,
    ButtonTertiaryBackgroundPressed: CaviarColors.Gray400,
    ButtonTertiaryForeground: CaviarColors.Gray600,
    ButtonTertiaryForegroundDisabled: CaviarColors.Gray400,
    ButtonTertiaryForegroundHovered: CaviarColors.Gray600,
    ButtonTertiaryForegroundPressed: CaviarColors.Gray600,
    ButtonTertiaryToggleBackground: CaviarColors.Gray600,
    ButtonTertiaryToggleBackgroundOff: 'SystemWhite',
    ButtonTertiaryToggleBackgroundDisabled: CaviarColors.Gray400,
    ButtonTertiaryToggleBackgroundHovered: CaviarColors.Gray500,
    ButtonTertiaryToggleBackgroundPressed: CaviarColors.Gray700,
    ButtonTertiaryToggleBackgroundOffDisabled: CaviarColors.Gray400,
    ButtonTertiaryToggleBackgroundOffHovered: CaviarColors.Gray200,
    ButtonTertiaryToggleBackgroundOffPressed: CaviarColors.Gray300,
    ButtonTertiaryToggleBorderOff: CaviarColors.Gray600,
    ButtonTertiaryToggleBorderOffHovered: CaviarColors.Gray500,
    ButtonTertiaryToggleBorderOffPressed: CaviarColors.Gray700,
    ButtonTertiaryToggleBorderOffDisabled: CaviarColors.Gray400,
    ButtonTertiaryToggleBorderOn: CaviarColors.Gray600,
    ButtonTertiaryToggleBorderOnHovered: CaviarColors.Gray500,
    ButtonTertiaryToggleBorderOnPressed: CaviarColors.Gray700,
    ButtonTertiaryToggleBorderOnDisabled: CaviarColors.Gray400,
    ButtonTertiaryToggleForeground: 'SystemWhite',
    ButtonTertiaryToggleForegroundDisabled: CaviarColors.Gray400,
    ButtonTertiaryToggleForegroundOff: CaviarColors.Gray600,
    ButtonTertiaryToggleForegroundOffDisabled: CaviarColors.Gray400,
    ButtonTertiaryToggleForegroundOffHovered: CaviarColors.Gray500,
    ButtonTertiaryToggleForegroundOffPressed: CaviarColors.Gray700,
    FieldsIconDropdown: CaviarColors.Gray600,
    FieldsIconSearch: CaviarColors.Gray600,
    FieldsInputBackgroundDisabled: CaviarColors.Gray100,
    FieldsInputBorder: CaviarColors.Gray300,
    FieldsInputBorderError: CaviarColors.Red400,
    ListCellContainerBackgroundHovered: CaviarColors.Gray100,
    ListCellContainerBackgroundPressed: CaviarColors.Gray200,
    ListCellIconToggledOn: CaviarColors.Orange200,
    ListCellIconToggledOff: CaviarColors.Gray400,
    LoadingDefault: CaviarColors.Orange200,
    OverlayBackgroundDefault: CaviarColors.Gray600,
    OverlayLoadingDefault: CaviarColors.Orange200,
    PageBackgroundSecondary: CaviarColors.Gray100,
    PageBackgroundTertiary: CaviarColors.Gray200,
    PaginationSelectedDark: CaviarColors.Gray400,
    PaginationSelectedPrimary: CaviarColors.Orange200,
    PaginationUnselectedDark: CaviarColors.Gray300,
    PaginationUnselectedPrimary: CaviarColors.Gray300,
    PaginationUnselectedLight: CaviarColors.Gray200,
    TextAction: CaviarColors.Orange200,
    TextCallout: CaviarColors.Orange200,
    TextError: CaviarColors.Red200,
    TextPrimary: CaviarColors.Gray600,
    TextPositive: CaviarColors.Green200,
    TextSecondary: CaviarColors.Gray500,
    TextSelected: CaviarColors.Orange200,
    TextTertiary: CaviarColors.Gray400,
    TextTooltip: CaviarColors.Gray400,
    TextWarning: CaviarColors.Yellow200,
    ToggleBackgroundOn: CaviarColors.Gray600,
    ToggleBackgroundOnDisabled: CaviarColors.Gray300,
    ToggleBackgroundOff: 'SystemWhite',
    ToggleBackgroundOffDisabled: CaviarColors.Gray100,
    ToggleBorderOn: CaviarColors.Gray600,
    ToggleBorderOnDisabled: CaviarColors.Gray300,
    ToggleBorderOff: CaviarColors.Gray600,
    ToggleBorderOffDisabled: CaviarColors.Gray100,
    ToggleForegroundOn: 'SystemWhite',
    ToggleForegroundOff: 'SystemWhite',
    ToggleForegroundOnDisabled: CaviarColors.Gray400,
    ToggleForegroundOffDisabled: 'SystemWhite',
    TooltipInformationalBackground: CaviarColors.Gray600,
    TooltipInformationalBackgroundHovered: CaviarColors.Gray700,
    TooltipInformationalBackgroundPressed: CaviarColors.Gray800,
    TooltipInformationalForeground: 'SystemWhite',
    TooltipInformationalForegroundHovered: 'SystemWhite',
    TooltipInformationalForegroundPressed: 'SystemWhite',
    WarningForeground: CaviarColors.Gray600,
    WarningBackground: CaviarColors.Yellow100
  },
  Icons: {
    Brand: IconsBrands.Caviar
  },
  Logo: {
    Brand: LogoBrands.Caviar
  },
  Typography: {
    FontFamily: 'Caviar-Market'
  }
};